import LearningStatistics from "./LearningStatistics";

export default LearningStatistics;
